import TreeMap from "react-d3-treemap"
// Include its styles in you build process as well
import "react-d3-treemap/dist/react.d3.treemap.css"
import { treeMapInPutData } from "./SampleData"

const TreeContainer = () => {

    return (
        <div className="tree-map-container">
            <TreeMap id="myTreeMap" height={560} data={treeMapInPutData}  />
        </div>
    )
}

export default TreeContainer